import React from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import IsolatedScroll from 'react-isolated-scroll';


// the key for the suggestion, we're returning specValue directly so no need to access property
const getSuggestionValue = suggestion => suggestion;


const renderSuggestion = suggestion => (
  <div>
    {suggestion}
  </div>
);

const CLEAR_SELECTION = '選択解除'

export default class SellerGroupModelListFilter extends React.Component {

  static propTypes = {
    filterSuggestions: PropTypes.any.isRequired,
    specId: PropTypes.any.isRequired,
    onChangeFromSpecTable: PropTypes.any.isRequired
  }

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      specValues: props.filterSuggestions,
      value: '',
      suggestions: []
    };
  }

  shouldRenderSuggestions = value => {
    return true;
  }


  emptyWhenSelectedValueIsClear(newValue) {
    return CLEAR_SELECTION === newValue ? '' : newValue;
  }

  // Teach Autosuggest how to calculate suggestions for any given input value.
  getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    let specsToDisplay = inputLength === 0
        ? this.props.filterSuggestions
        : this.props.filterSuggestions.filter(specValue => specValue.toLowerCase().slice(0, inputLength) === inputValue);

    // limit results to display since rendering all elements is expensive
    // add clear on beggining of results
    return [CLEAR_SELECTION].concat(specsToDisplay.slice(0,100));
  };

  onChange = (event, { newValue,method }) => {
    this.setState({
      value: this.emptyWhenSelectedValueIsClear(newValue)
    });
  };

  onBlur = (event, { highlightedSuggestion }) => {
    this.props.onChangeFromSpecTable(this.emptyWhenSelectedValueIsClear(event.target.value));
  }

  onKeyDown = (event) => {
    if (event.key === 'Enter') {
      this.props.onChangeFromSpecTable(this.emptyWhenSelectedValueIsClear(event.target.value));
    }
  }

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  renderSuggestionsContainer = ({ containerProps, children }) => {
    const { ref, ...restContainerProps } = containerProps;
    const callRef = isolatedScroll => {
      if (isolatedScroll !== null) {
        ref(isolatedScroll.component);
      }
    };

    return (
      <IsolatedScroll ref={callRef} {...restContainerProps}>
        {children}
      </IsolatedScroll>
    );
  }

  // Clearing does not trigger this, use componentDidUpate instead
  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
    console.log('onsuggestionseleced: ', method)
    this.props.onChangeFromSpecTable(this. emptyWhenSelectedValueIsClear(suggestionValue));
  };

  render() {
    const { value, suggestions} = this.state;
    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: '',
      value,
      onChange: this.onChange,
      onBlur: this.onBlur,
      onKeyDown: this.onKeyDown
    };

    return (
      <div className="filterIcon">
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          onSuggestionSelected={this.onSuggestionSelected}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps}
          shouldRenderSuggestions={this.shouldRenderSuggestions}
          renderSuggestionsContainer={this.renderSuggestionsContainer}
        />
        <i className="fa fa-filter"/>
      </div>
    );
  }
}